import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import FooterContainer from 'src/components/footer/footer';
import { Link } from 'react-router-dom';

function ChickenRoadPromo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // const domain = (brandId == 31 || brandId == 32 || brandId == 61) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7": 'IW247';

    return (
        <>
            <InformationWrapper>
                {/* <TitleText>
                    {
                        (brandId == 31 || brandId == 32) ? <p>Win up to <span className='brandColor'>₹90,000 Cash</span> this September on Evoplay</p> :
                            (brandId == 33 || brandId == 34) ? <p>Enjoy <span className='brandColor'>₹3000 daily</span> rewards on Uncrossable Rush - <span className='brandColor'>the more you spin, the more you win!</span></p> :
                                (brandId == 61) ? <p>🎁 Win up to <span className='brandColor'>$900 Cash</span> this September on Evoplay</p> :
                                <p>Get <span className='brandColor'>₹3,000 daily</span> on Uncrossable Rush - just keep spinning!</p>
                    }
                </TitleText> */}
                <ImageWrapper>
                    <Container>
                          <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.chickenRoadFirstSec}`}
                                alt="How to participate"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                           />
                           <Link to='/instant-games/inout/chicken-road-2' className='playNowBtn'><span>Play Now</span></Link>
                    </Container>
                </ImageWrapper> 

                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.chickenRoadParticipateIcon1}`}/>
                            <p>Play Chicken Road 2 from the InOut provider for the first time</p>
                        </KeyDetailsSecBox>
                             
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.suprChknRushParticipateIcon2}`}/>
                            <p className='largeFont'><span className='brandColor'>Activate your 10 Free Rounds</span> and start spinning!</p>
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ul>
                        <li>✪ Offer valid only for first-time players of <span className='brandColor'>Chicken Road 2 (InOut)</span>.</li>
                        <li>✪ Each Free Spin is worth <span className='brandColor'>₹10</span>.</li>
                        <li>✪ Winnings from Free Spins are capped at <span className='brandColor'>1x</span>.</li>
                        <li>✪ Standard Terms & Conditions apply.</li>
                    </ul>

                    {/* {(brandId == 61) ? 
                        <ul>
                            <li>✪ only bets of $1 or more per spin qualify.</li>
                            <li>✪ Winnings from Free Cash capped at 1x per day.</li>
                            <li>✪ Maximum of $30 per day per player.</li>
                            <li>✪ Standard brand T&Cs apply</li>
                        </ul> 
                        : 
                        <ul>
                            <li>✪ Only bets of ₹75 or more per spin qualify.</li>
                            <li>✪ Winnings from Free Cash capped at 1x per day.</li>
                            <li>✪ Maximum of ₹3,000 per day per player.</li>
                            <li>✪ Standard brand T&Cs apply.</li>
                        </ul>
                    } */}
                </TermsAndCondition>
                
            </InformationWrapper>
            <FooterContainer />
        </>
    )
}



export default withTheme(withAppContext(ChickenRoadPromo));

const BorderLine = styled.div`
    width: 100%;
    background: ${theme('palette.jiliPlaySpinBorderLineBg')};
    height: 1px;
    align-self: center;
`;

const UnderLine = styled.div`
    height: 1px;
    width: 184px;
    background: radial-gradient(#FFF 0%, rgba(153, 153, 153, 0.00) 80%);

    &.paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    &.marginTop {
        margin: 0 auto;
        margin-top: 1rem;
    }
`;

const SliderWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 738px;
        max-width: 100%;
    }
`;

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 2rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.chickenRoadMainInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    .boldText {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 700;
    }

    .boldTextLite {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 400;
    }

    h2 {
        color: #FAFF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        /* background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')}; */
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    .brandColor {
        font-weight: 700;
    }

    .bgRadial {
        background: ${theme('palette.jiliPlaySpinBgRadial')};
    }

    .largeFont {
        font-size: 18px;
    }
`;

// const PriceBreakDown = styled.div`
//     width: 80%;
//     padding: 2rem 0;
//     position: relative;
//     margin: auto;
// `;

// const TitleText = styled.div`
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     flex-direction: column;
//     padding: ${theme('palette.liveJackpotTittleTextPadding')};
//     position: relative;
//     gap: 15px;

//     p {
//         color: #FFF;
//         text-align: center;
//         font-size: 15px;
//         font-style: normal;
//         font-weight: 400;
//         line-height: 28px; /* 186.667% */
//         text-transform: capitalize;
//         margin: 0;
//     }

//     .mt-10 {
//         margin-top: 15px;
//     }
// `;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    padding-top: ${theme('palette.suprChknRushImageWraprPaddngTop')};

    img {
        width: 93px;
    }

    .customMargin {
        margin: -7px 0px -20px 0px;
    }
`;

const Container = styled.div`
    width: 275px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 100%;
      height: auto;
    }

    .playNowBtn {
        width: 220px;
        height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
        margin-top: 1.5rem;
        /* border-radius: 60px;
        border: ${theme('palette.suprChknRushPlayNowBtnBorder')};
        background: ${theme('palette.suprChknRushPlayNowBtnBgColor')}; */
        border-radius: 59px;
        border: 3px solid #FCFF72;
        background: #FAFF00;

        :hover {
            background: #fff;
            border: 3px solid #bebebe;
        }
    }

`;

const MainTitle = styled.h4`
    /* color: ${theme('palette.weeklySepLeaderboardText')}; */
    color: #FAFF00;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;
`;


const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 2rem auto;
    width: 70%;
    height: auto;
`;

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
`;

const KeyDetailsSecBox = styled.div`
    width: 313px;
    height: 190px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    border-radius: 14px;
    background: linear-gradient(0deg, #CA271A 0%, #CA271A 100%), linear-gradient(180deg, #EDE9EE 0%, #C5BABE 100%);
    /* border-radius: ${theme('palette.weeklySepLeaderBoardPartBoxBodrRadus')};
    border: 0.5px solid ${theme('palette.weeklySepLeaderBoardPartBoxBorder')};
    background: ${theme('palette.weeklySepLeaderBoardPartBoxBg')}; */

    img {
        width: 61px;
    }

    & p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 133.333% */
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`;

const TermsAndCondition = styled.div`
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 2rem auto;
    border-radius: 14px;
    padding: 1rem;
    /* border: ${theme('palette.suprChknRushTCBorder')};
    background: ${theme('palette.suprChknRushTCBg')}; */
    /* backdrop-filter: ${theme('palette.suprChknRushTCBGFilter')}; */

    border: 1px solid #F0B541;
    background: rgba(202, 39, 26, 0.50);
    backdrop-filter: blur(12px);
    
    ul {
        list-style: none;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;

        li {
            color: #fff;
            font-size: 16px;
            text-transform: capitalize;
        }
    }
`;